import { DocumentFile, ProjectType, TradeType } from '@shared/models';

export enum ProjectSetupStep {
  SummarizingFiles = 0,
  Completed = 1,
  Failed = 2,
  ProcessingProject = 3,
}

export enum ProjectSetupDataType {
  Name = 0,
  StartDate = 1,
  EndDate = 2,
  ConstructionArea = 3,
  Phase = 4,
  Activity = 5,
}

export interface ProjectSetupSuggestion {
  type: ProjectSetupDataType;
  value: string;
  fileId?: string;
  fileName?: string;
  pageNumber?: number;
  projectId?: string;
  sourceProjectName?: string;
}

export interface SetupProgress {
  projectId: string;
  currentStep: ProjectSetupStep;
  overallPercentage: number;
  suggestions: ProjectSetupSuggestion[];
}

export interface AutomaticProjectSetup {
  name: string;
  tradeType: TradeType;
  projectType: ProjectType;
  files: DocumentFile[];
}
